export const isNotificationBanner = () => {
    const fandomBanner = document.querySelector('.banner-notifications-placeholder');
    const isBannerVisible = fandomBanner ? fandomBanner.offsetHeight !== 0 : false;
    return isBannerVisible;
};
